module.exports = __webpack_public_path__ + "img/raw.7d5457aa.svg";